import React from "react";
import "../styles/About.css"; 
import FaqSection from "../components/FaqSection/FaqSection";

const CourseDetail = () => {
  return (
    <>
      <section className="banner_area">
        <div className="banner_inner d-flex align-items-center">
          <div className="overlay bg-parallax"></div>
          <div className="container">
            <div className="banner_content text-center">
              <h2>Regular FAQs</h2>
              <div className="page_link">
                <a href="/">Home</a>
                <span className="breadcrumb-arrow">→</span>
                <a href="/faq">Regular FAQs</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    <FaqSection/>
    </>
  );
};

export default CourseDetail;
